import { Fragment, useState, useEffect } from "react";
import { Box, Typography, Radio, CircularProgress } from '@mui/material';
import { useForm } from "./../../context/FormContext";
import fetchRates from './../../api/fetchRates';

const myStyle = {
    background: '#6EA3D5',
    padding: '8px',
    border: '5px',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    borderTopRight:'5px'
};

const PageTitle = () => <Typography
    variant='h6'
    style={myStyle}
    fontWeight={"bold"} >
    Select the Parcel Sizes
</Typography>

const ParcelInfo = ({ type }) => {
    const { formData, updateField } = useForm();
    const [loadingParcelLoading, setParcelLoading] = useState(false);

    const getParcelRates = async () => {
        try {
            updateField('parcelSizesLoading',true);
            const delivery_type_address = (type.includes('_locker')) ? 'locker' : ((type.includes('_pp')) ? 'pickup point' : 'kiosk');
            const collection_type_address = (type.includes('locker_')) ? 'locker' : ((type.includes('pp_')) ? 'pickup point' : 'kiosk');
            const result = await fetchRates({
                collection_address: {
                    type: collection_type_address
                },
                delivery_address: {
                    type: delivery_type_address
                },
            }, type.includes('pp_') ? 'point' : 'kiosk');
            updateField('parcelSizes',result);
            updateField('parcelErrorMessage', null);
        } catch (err) {
            updateField('parcelSizesLoading', false);
            updateField('parcelErrorMessage', err.message);
        } finally {
            updateField('parcelSizesLoading', false);
        }
    };

    useEffect(() => {
        if (!type.includes('_door')){
            getParcelRates()
        }
    }, [type]);
    
    return <Fragment>
        <PageTitle />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1,backgroundColor:'white',padding: '10px' }}>
            {
                (formData.parcelSizesLoading === true) ? (
                    <div className='flex flex-col justify-center justify-items-center items-center'>
                        <div>
                            <CircularProgress className="progress" color="secondary" />
                        </div>
                        <div>
                            <h3 className='font-semibold mt-1 text-blue-400'>Loading rates. Please wait.</h3>
                        </div>
                    </div>
                ) : ( 
                    !formData.parcelErrorMessage ? (
                        formData.parcelSizes && formData.parcelSizes.rates.map((value, index) => {
                            const { width, height, length, weight } = value.service_level.dimensions;
                            return <div key={value.service_level.id} className="mb-3 ">

                                <div className={`p-2 flex flex-column justify-between ${(index !== 0) ? 'border-t-2 border-[#E6E7E8]' : ''}`}>
                                    <div className="flex-row ">
                                        <div><span className="text-lg font-bold">{value.service_level.name}</span></div>
                                        <div><span className="text-sm text-zinc-500">Dimension and weight (max.)</span></div>
                                        <div><span className="text-sm ">{`${width}cm X ${height}cm X ${length}cm - ${weight}kg`}</span></div>
                                        <div className="mt-3">
                                            <div>Price</div>
                                            <div><span className="text-sm font-semibold">R{value.rate}</span></div>
                                        </div>
                                    </div>
                                    <div>
                                        <Radio
                                            required
                                            checked={formData.parcelPrice === value.service_level.code}
                                            onChange={() => updateField("parcelPrice", value.service_level.code)}
                                            value={value.service_level.code}
                                            name="parcelPrice"
                                            inputProps={{ 'aria-label': value.service_level.code }}
                                            color="success"
                                        />
                                    </div>
                                </div>
                            </div>
                            }
                        )
                    ) : (
                        <div className="p-10 text-center">
                            <span className="text-red-800 font-semibold">{formData.parcelErrorMessage}</span>
                        </div>
                    )
                )
            }
        </Box>
    </Fragment>
}

export default ParcelInfo;